module.exports = __webpack_public_path__ + "img/edit-hover.7f03525e.svg";